import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { axiosInstance } from '../../utils/axios';
import {
  createInvoiceFailure,
  createInvoiceRequest,
  createInvoiceSuccess,
  editInvoiceFailure,
  editInvoiceRequest,
  editInvoiceSuccess,
  fetchInvoiceById,
  fetchInvoiceByIdFailure,
  fetchInvoiceByIdSuccess,
  fetchInvoicesFailure,
  fetchInvoicesRequest,
  fetchInvoicesSuccess,
} from './invoiceSlice';

function* fetchInvoicesSaga(action) {
  try {
    ('fetchInvoicesSaga');
    const { page, limit, stripe_subscription_id } = action.payload;
    const params = {
      page,
      limit,
      stripe_subscription_id,
    };
    const response = yield call(axiosInstance.get, '/invoices', { params });
    yield put(fetchInvoicesSuccess(response.data));
  } catch (error) {
    yield put(fetchInvoicesFailure(error.message));
  }
}

function* fetchInvoiceByIdSaga(action) {
  try {
    const response = yield call(axiosInstance.get, `/invoices/${action.payload}`);
    yield put(fetchInvoiceByIdSuccess(response.data));
  } catch (error) {
    yield put(fetchInvoiceByIdFailure(error.message));
  }
}

function* editInvoiceRequestSaga(action) {
  try {
    const { _id, __v, createdAt, updatedAt, ...sanitizedPayload } = action.payload;
    const response = yield call(axiosInstance.put, `/invoices/${_id}`, sanitizedPayload);
    yield put(editInvoiceSuccess(response.data));
  } catch (error) {
    yield put(editInvoiceFailure(error.response.data.error));
  }
}

function* createInvoiceSaga(action) {
  try {
    const response = yield call(axiosInstance.post, '/invoices', action.payload);
    yield put(createInvoiceSuccess(response.data));
  } catch (error) {
    yield put(createInvoiceFailure(error.response.data.errors));
  }
}

function* invoiceSaga() {
  yield takeLatest(fetchInvoicesRequest.type, fetchInvoicesSaga);
  yield takeEvery(fetchInvoiceById.type, fetchInvoiceByIdSaga);
  yield takeLatest(createInvoiceRequest.type, createInvoiceSaga);
  yield takeLatest(editInvoiceRequest.type, editInvoiceRequestSaga);
}

export default invoiceSaga;
